<div class="container py-2">
    <ng-container *ngIf="anmeldungenAktiv">
        <h3>Vielen Dank für Ihre Anmeldung!</h3>
        <p>
            Sie haben Ihr Kind erfolgreich für die gewünschten Aktionen angemeldet. Das T.o.J.-Team wird alle
            Anmeldungen
            zeitnah prüfen. Sobald die Prüfung abgeschlossen ist, erhalten Sie eine Anmeldebestätigung per E-Mail. Darin
            erfahren Sie, für welche Aktionen Ihr Kind verbindlich angemeldet ist und bei welchen Aktionen es ggf. einen
            Platz auf der Warteliste erhalten hat. <br><br>
            Bitte überweisen Sie erst nach der Bestätigung den fälligen Teilnahmebetrag innerhalb von 3 Werktagen, um
            den Platz verbindlich zu sichern. Ohne fristgerechte Zahlung wird der Platz automatisch weitervergeben.
        </p>
    </ng-container>
    <ng-container *ngIf="!anmeldungenAktiv">
        <h3>Voranmeldung abgeschlossen!</h3>
        <p>
            Sie haben Ihre Kinder erfolgreich zu den gewünschten Aktionen <b>vorangemeldet</b>.
            Ab dem <b>{{ anmeldungenDatum | datum }} um {{ anmeldungenDatum | zeit }}</b> können Sie die Voranmeldungen
            verbindlich an das T.o.J.-Team übermitteln. 24 Stunden vorher sehen Sie hier einen Timer. Sobald dieser
            Timer abgelaufen ist, erscheint ein Button „Kinder anmelden“ mit dem Sie die Voranmeldungen an das
            T.o.J.-Team übermitteln können.<br><br>
            Nach Eingang Ihrer finalen Anmeldung wird das T.o.J.-Team alle Anfragen prüfen. Anschließend erhalten Sie
            eine <b>Bestätigungs-E-Mail</b> mit den Informationen, für welche Aktionen Ihre Kinder verbindlich gebucht
            sind. Bedenken Sie bitte das uns sehr viele Buchungen erreichen. Bis die Bestätigungs-E-Mail kommt, kann es
            also einen Moment dauern.<br><br>
            <b>Bitte beachten:</b> Erst mit dem Erhalt dieser E-Mail ist die Teilnahme gesichert.
        </p>
    </ng-container>

    <div class="row">
        <div class="col-12 col-md-6 col-lg-4 mb-3" *ngFor="let k of kinder">
            <div class="card h-100">
                <div class="card-header">
                    <h5 class="mb-0">{{ k.vorname }}</h5>
                    <small class="text-muted">ID: {{ k.id }}</small>
                </div>
                <ng-container *ngIf="getAnmeldungenList(k) as list">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between align-items-center grayBgColor">
                            <span>Vorangemeldet</span>
                            <span class="badge badge-primary badge-pill">{{ list.vorangemeldet }}</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center grayBgColor">
                            <span>Angemeldet</span>
                            <span class="badge badge-success badge-pill">{{ list.angemeldet }}</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center grayBgColor">
                            <span>Warteliste</span>
                            <span class="badge badge-warning badge-pill">{{ list.warteliste }}</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center grayBgColor">
                            <span>Gebucht</span>
                            <span class="badge badge-info badge-pill">{{ list.gebucht }}</span>
                        </li>
                    </ul>
                    <div class="card-footer text-center" *ngIf="list.angemeldet > 0">
                        <button class="btn pcButton" ngbTooltip="Anmeldung downloaden" (click)="download(k)">
                            <i class="fas fa-download"></i> Download
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

</div>
